import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as Sentry from '@sentry/browser';

type translationLookupResponse = {
  updatedAt?: string;
  translations?: Record<string, string>;
};

@Injectable({
  providedIn: 'root',
})
export class TranslationLookupService {
  constructor(private apollo: Apollo) {}

  lookupAndTranslate(
    untranslatedText: string[],
    locale: string,
  ): Observable<translationLookupResponse> {
    const LOOKUP_AND_TRANSLATE_MUTATION = gql`
      mutation LookupAndTranslate($englishTexts: [String!]!, $locale: String!) {
        lookupAndTranslate(englishTexts: $englishTexts, locale: $locale)
      }
    `;

    return this.apollo
      .mutate<{
        lookupAndTranslate: translationLookupResponse;
      }>({
        mutation: LOOKUP_AND_TRANSLATE_MUTATION,
        variables: { englishTexts: untranslatedText, locale },
      })
      .pipe(
        map((result) => result.data.lookupAndTranslate), // Extract only the needed data
        catchError((error) => {
          Sentry.captureException(error);
          console.error('Error in translation lookup and translate:', error);
          throw error; // Re-throw so the subscriber can handle it
        }),
      );
  }
}
